import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useForm, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import CustomizedDialogs from '../components/ModalAlert';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import { useQuery } from '../hooks/useQuery';
import Moment from 'moment';
import { useAuth } from '../hooks/useAuth';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';
import { useSnackbar } from '../hooks/useSnackbar';
import UploadIcon from '@mui/icons-material/Upload';

import { decryptData, encryptData, handleHttpError, isCnpj } from '../utils';
import readXlsxFile from 'read-excel-file';
import { useModalLoading } from '../hooks/useModalLoading';

let debounce = null;

export const PagamentoFormPage = ({
  activeStep,
  setActiveStep,
  steps,
  setPagamentoDiretoId,
  setNumeroDocumentoFiscal,
}) => {
  const { user, isUsuarioSebrae } = useAuth();
  const {
    getCombos,
    getSaldo,
    listarFornecedores,
    enviarPagamentoDireto,
    getPagamentoDireto,
    enviarArquivosPagamentoDireto,
    listarBancos,
    buscaCC,
    obterFornecedorPorCnpj,
    listarClientes,
    parserBoleto,
    parserFatura,
  } = useQuery();
  const datePickerRef = React.useRef();
  const dateValidadePickerRef = React.useRef();
  const datePeriodoPickerRef = React.useRef();
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [show, setShow] = React.useState(false);
  const snackbar = useSnackbar();
  const modalLoading = useModalLoading();

  const [queryParamsDocument, setQueryParamsDocument] = React.useState({
    busca: '',
  });
  const [queryParamsFornecedor, setQueryParamsFornecedor] = React.useState({
    busca: '',
  });
  const [loadingAutocomplete, setLoadingAutocomplete] = React.useState(false);
  const [loadingAutocompleteCC, setLoadingAutocompleteCC] =
    React.useState(false);
  const [loadingAutocompleteOrc, setLoadingAutocompleteOrc] =
    React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [optionsEstab, setOptionsEstab] = React.useState([]);
  const [optionsUndNeg, setOptionsUndNeg] = React.useState([]);
  const [optionsCCustos, setOptionsCCustos] = React.useState([]);
  const [optionsContaContabil, setOptionsContaContabil] = React.useState([]);

  const [formValues, setFormValues] = React.useState([
    {
      estab: '',
      unidNeg: '',
      ccustos: '',
      contaContabil: '',
      saldo: 0,
      valor: 0,
      isContaContabil: false,
    },
  ]);
  const [solicPagamentoDireto, setSolicPagamentoDireto] = React.useState(true);
  const [dadosSolic, setDadosSolic] = React.useState(true);
  const [dadosContratacao, setDadosContratacao] = React.useState(true);
  const [classOrcamentaria, setClassOrcamentaria] = React.useState(true);
  const [justifiqueMotivo, setJustifiqueMotivo] = React.useState(true);
  const [hideFields, setHideFields] = React.useState(false);
  const [fornecedor, setFornecedor] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [saldo, setSaldo] = React.useState([]);
  const [pagamento, setPagamento] = React.useState(null);
  const [formPagamentoSelecionado, setFormPagamentoSelecionado] =
    React.useState(null);
  const [isAntecipacao, setIsAntecipacao] = React.useState(false);
  const [isCancelamentoSem, setIsCancelamentoSem] = React.useState(false);
  const [isCancelamentoCom, setIsCancelamentoCom] = React.useState(false);
  const [isPagamentoMaior, setIsPagamentoMaior] = React.useState(false);
  const [isOrdemPagamento, setIsOrdemPagamento] = React.useState(false);
  const [txtJustificativa, setTxtJustificativa] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [bancos, setBancos] = React.useState([]);
  const theme = useTheme();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let [fileImportedIA, setFileImportedIA] = React.useState(null);

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const onChangeTxtJustificativa = () => {
    let tipo = isCancelamentoCom
      ? 'venda com devolução'
      : isPagamentoMaior
      ? 'pagamento maior'
      : 'venda sem devolução';
    let txt = `Solicitamos o cancelamento de ${tipo} de valores ao cliente ${
      fornecedor.nome_fornec
    }, CPF/CNPJ ${
      fornecedor.cnpj_fornec
    }. Trata-se do contrato numero ${getValues(
      'documento_fiscal',
    )}, que será cancelado ${getValues(
      'cancelar',
    )} conforme justificativa abaixo:`;
    setTxtJustificativa(txt);
  };
  const buscarPagamento = async () => {
    if (!searchParams.get('pagamento_id')) return;

    setIsLoading(true);
    const pagamento_id = decryptData(searchParams.get('pagamento_id'));

    if (!pagamento_id) {
      return navigate('/dashboard/pagamento-direto');
    }

    const { data } = await getPagamentoDireto(pagamento_id);

    let classOrc = [];
    setNumeroDocumentoFiscal(data.data.numero_fiscal);
    data.data.classificacao_orcamentaria.forEach((res, index) => {
      const conta_contabil = JSON.parse(res.conta_contabil);
      const estbParsed = JSON.parse(res.estab);
      const unidadeNegocioParsed = JSON.parse(res.unidade_negocio);
      const centroCustoParsed = JSON.parse(res.centro_custo);

      let estab =
        estbParsed === null
          ? { id: 0, cod: '0', desc: '' }
          : estbParsed.id === 0
          ? null
          : estbParsed;
      let unidade_negocio =
        unidadeNegocioParsed === null
          ? { id: 0, cod: '0', desc: '' }
          : unidadeNegocioParsed.id === 0
          ? null
          : unidadeNegocioParsed;
      let centro_custo =
        centroCustoParsed === null
          ? { id: 0, cod: '0', desc: '' }
          : centroCustoParsed.id === 0
          ? null
          : centroCustoParsed;

      classOrc.push({
        estab: estab,
        unidNeg: unidade_negocio,
        ccustos: centro_custo,
        contaContabil: conta_contabil,
        saldo: res.saldo,
        valor: res.valor,
        isContaContabil:
          conta_contabil !== null
            ? isUnnecessaryValidadeBalance(conta_contabil)
            : false,
      });
    });

    if (data.data.ordem_pagamento == 'Ordem de Pagamento') {
      setIsOrdemPagamento(true);
    } else {
      setIsOrdemPagamento(false);
    }
    setFormValues(classOrc);
    setPagamento(data.data);
    fornecedores(data.data.documento_fornecedor);
    setValue('telefone', data.data.telefone);
    setValue('email', data.data.email);
    setValue('data_abertura', data.data.created_at);
    setValue('tipo_contratacao', data.data.tipo_contratacao);
    setValue('data_validade', data.data.data_validade);
    setValue('data_emissao', data.data.data_emissao);
    setValue('periodo_entrega', data.data.periodo_produto);
    setValue('documento_fiscal', data.data.numero_fiscal);
    setValue('forma_pagamento', data.data.forma_pagamento);
    setValue('codigo_boleto', data.data.codigo_boleto);
    setFormPagamentoSelecionado(data.data.forma_pagamento);

    if (
      data.data.tipo_documento == 'cancelaVendaDevolucao' ||
      data.data.tipo_documento == 'cancelaVendaComDevolucao' ||
      data.data.tipo_documento == 'pagamentoMaiorPeloCliente'
    ) {
      setValue('instrumento', data.data.instrumento);
      setValue('cancelar', data.data.cancelar);
      setValue('contrato_assinado', data.data.contrato_assinado);
      setValue('descricao_servico', data.data.descricao_servico);
      setValue('valor', data.data.valor);
      setValue('banco', data.data.banco);
      setValue('agencia', data.data.agencia);
      setValue('conta', data.data.conta);
      setValue('digito', data.data.digito);
      setValue('digito_agencia', data.data.digito_agencia);
      setValue('endereco', data.data.endereco_completo);
    }
    setValue('justificativa', data.data.justificativa);
    setValue('tipo_documento', data.data.tipo_documento);
    onChangeTipoDocumento(data.data.tipo_documento);
    setIsLoading(false);
  };

  const getBancos = async () => {
    const result = await listarBancos();
    if (result && result.data) {
      setBancos(result.data.data);
    }
  };

  const converToFloat2 = (currency) => {
    let result = String(currency).split('.').join('');
    result = result.replace(',', '.');

    var value = parseFloat(result);
    return value.toFixed(2);
  };

  React.useEffect(() => {
    if (datePickerRef) {
      datePickerRef.current.children[0].classList.remove('Mui-error');
      datePickerRef.current.children[1].classList.remove('Mui-error');
    }
    if (dateValidadePickerRef) {
      dateValidadePickerRef.current.children[0].classList.remove('Mui-error');
      dateValidadePickerRef.current.children[1].classList.remove('Mui-error');
    }
    if (datePeriodoPickerRef) {
      // dateValidadePickerRef.current.children[0].classList.remove("Mui-error");
      // datePeriodoPickerRef.current.children[1].classList.remove("Mui-error");
    }
  }, [datePickerRef, dateValidadePickerRef, datePeriodoPickerRef]);

  React.useEffect(() => {
    if (fornecedor) {
      onChangeTxtJustificativa();
    }
  }, [fornecedor]);

  const isValidRowClassificacaoOrcamentaria = (index) => {
    const form = formValues[index];

    const saldo = parseFloat(form.saldo);

    if (!form.isContaContabil && saldo === 0) {
      return false;
    }

    return true;
  };

  const onChangeFile = async (event) => {
    if ([...event.target.files].length === 0) return;
    const f = event.target.files[0];
    const extension = f.name.split('.').pop();
    if (!['pdf'].includes(extension.toLowerCase())) {
      snackbar.showSnackbar(
        'Tipo de arquivo inválido. Somente PDF é permitido',
      );
      return;
    }

    try {
      modalLoading.show('Inteligência artificial analisando seu PDF. Aguarde!');
      setFileImportedIA(f);
      const form = new FormData();
      form.append('arquivo', f);

      let data = null;
      if (getValues('forma_pagamento') === 'FaturaCtaConsumo') {
        const response = await parserFatura(form);
        data = response.data;
      } else {
        const response = await parserBoleto(form);
        data = response.data;
      }
      if (data.data) {
        setValue('codigo_boleto', data.data.digits ?? '');
        setValue('data_validade', data.data.due_date ?? '');
      }
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      modalLoading.hide();
    }
  };

  const onChangeXlsx = async (event) => {
    const file = event.target.files[0];
    event.target.value = '';

    if (!['xls', 'xlsx'].includes(file.name.split('.').pop())) {
      snackbar.showSnackbar('Tipo de arquivo inválido');
      return;
    }
    try {
      const rows = await readXlsxFile(file);

      const itemsImport = [];
      rows.forEach(async (item, idx) => {
        if (idx === 0) return;

        if (item.length !== 5) {
          throw 'Número de colunas inválido';
        }

        const contaContabil = optionsContaContabil.find(
          ({ cod }) => cod === item[0],
        );
        const estab = optionsEstab.find(({ cod }) => cod === item[1]);
        const unidNeg = optionsUndNeg.find(
          ({ cod }) => cod === item[2].toString(),
        );

        let finalccustos = null;

        if (item[3]) {
          const ccustos = optionsCCustos.find(
            ({ cod }) => cod === item[3].toString(),
          );

          finalccustos = ccustos || null;
        }

        if (
          contaContabil !== null &&
          contaContabil !== undefined &&
          isUnnecessaryValidadeBalance(contaContabil)
        ) {
          finalccustos = null;
        }
        const finalValue = parseFloat(item[4]);
        itemsImport.push({
          estab: estab || null,
          unidNeg: unidNeg || null,
          ccustos: finalccustos,
          contaContabil: contaContabil || null,
          isContaContabil:
            contaContabil !== null && contaContabil !== undefined
              ? isUnnecessaryValidadeBalance(contaContabil)
              : null,
          saldo: 0,
          valor: isNaN(finalValue) ? 0 : finalValue,
        });
      });
      modalLoading.show('Buscando saldo das classificações orçamentárias....');
      const finalItemsImport = await validarSaldoCentroDecusto(itemsImport);

      setFormValues([...finalItemsImport]);
    } catch (error) {
      console.log(error);
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      modalLoading.hide();
    }
  };

  const validarSaldoCentroDecusto = (items) => {
    return new Promise((res, rej) => {
      const percRateio = arredondar(100 / items.length);

      const promises = items.map(async (item, idx) => {
        if (
          !item.estab ||
          !item.unidNeg ||
          !item.ccustos ||
          !item.contaContabil
        ) {
          return;
        }

        try {
          const params = `${percRateio}/${item.estab.cod}/${item.unidNeg.cod}/${item.ccustos.cod}/${item.contaContabil.cod}`;
          const { data } = await getSaldo(params);
          item.saldo = parseFloat(
            converToFloat2(
              data.data['Saldo Clas Orctaria'][0]['sdo_calculado'],
            ),
          );
        } catch (error) {
          console.log(error);
        }
      });

      Promise.all(promises)
        .then(() => res(items))
        .catch((error) => console.log(error));
    });
  };

  const commbosData = async () => {
    setLoadingAutocompleteOrc(true);
    let resultEstab = getCombos('estabelecimento');
    let resultUndNeg = getCombos('undnegocio');
    let resultCcusto = getCombos('ccustos');
    let resultConta = getCombos('ccontabil');

    [resultEstab, resultUndNeg, resultCcusto, resultConta] = await Promise.all([
      resultEstab,
      resultUndNeg,
      resultCcusto,
      resultConta,
    ]);

    setOptionsEstab(resultEstab.data.data);
    setOptionsCCustos(resultCcusto.data.data);
    setOptionsUndNeg(resultUndNeg.data.data);
    setOptionsContaContabil(resultConta.data.data);
    setLoadingAutocompleteOrc(false);
  };

  React.useEffect(() => {
    if (pagamento && options && options.length > 0) {
      const cnpjEncontrado = options.filter(
        ({ cnpj_sem_pontos }) =>
          pagamento.documento_fornecedor === cnpj_sem_pontos,
      );
      if (cnpjEncontrado.length > 0) {
        setFornecedor(cnpjEncontrado[0]);
      }
    }
  }, [options]);

  React.useEffect(() => {
    if (!optionsContaContabil.length) return;
    if (!isLoading) return;

    buscarPagamento();
  }, [optionsContaContabil]);

  React.useEffect(() => {
    if (!fornecedor) return;
    const { cnpj_sem_pontos, email, telefone } = fornecedor;
    if (
      ['cancelaVendaComDevolucao', 'pagamentoMaiorPeloCliente'].includes(
        getValues('tipo_documento'),
      )
    ) {
      setValue('email', email);
      setValue('telefone', telefone);
      return;
    }

    obterFornecedorPorCnpj(cnpj_sem_pontos).then(({ data }) => {
      setValue('email', data.data.email_fornec);
      setValue('telefone', data.data.telef_fornec);
    });
  }, [fornecedor]);

  const fornecedores = async (term) => {
    setLoadingAutocomplete(true);
    const newTerm = term.replace(/[^a-zA-Z0-9]/g, '');

    if (
      ['cancelaVendaComDevolucao', 'pagamentoMaiorPeloCliente'].includes(
        getValues('tipo_documento'),
      )
    ) {
      const result = await listarClientes(term);

      if (result && result.data && result.data.data) {
        const arr = result.data.data.map((item) => ({
          ...item,
          cnpj_sem_pontos: item.cod_id_feder.replace(/[^a-zA-Z0-9]/g, ''),
          nome_fornec: item.nom_razao_social,
          cnpj_fornec: item.cod_id_feder,
          cod_fornec: item.cod_emitente,
        }));
        setOptions(arr);
      }
      setLoadingAutocomplete(false);
      return;
    }

    const result = await listarFornecedores(newTerm);
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
        cnpj_sem_pontos: item.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, ''),
      }));
      setOptions(arr);
    }
    setLoadingAutocomplete(false);
  };

  const centroCusto = async (term) => {
    setLoadingAutocompleteCC(true);

    const result = await buscaCC(`?term=${term}`);
    if (result && result.data && result.data.data) {
      setOptionsCCustos(result.data.data);
    }
    setLoadingAutocompleteCC(false);
  };

  const saldoData = async (param) => {
    const result = await getSaldo(param);

    setSaldo(
      converToFloat2(
        result.data.data['Saldo Clas Orctaria'][0]['sdo_calculado'],
      ),
    );
    let newFormValues;
    if (user && user.role_id == 6) {
      newFormValues = [
        {
          estab: {
            id: 47,
            cod: 'SED',
            desc: 'SERVICO DE APOIO AS MICRO E PEQUENAS EMPRESAS DE MINAS GERAIS - SEBRAE/MG',
          },
          unidNeg: { id: 43, cod: '163', desc: 'Inovação e Mercado - UIMER' },
          ccustos: { id: 1231, cod: '5045406', desc: 'Projetos de Inovação' },
          contaContabil: {
            id: 390,
            cod: '31380103',
            desc: 'GESTÃO DE PROJETOS DE INOVAÇÃO',
          },
          saldo: 0,
          valor: 0,
        },
      ];
    } else {
      newFormValues = [...formValues];
    }

    newFormValues.forEach((val, index) => {
      if (
        val.ccustos &&
        val.ccustos !== '' &&
        val.contaContabil &&
        val.contaContabil !== '' &&
        val.estab &&
        val.estab !== '' &&
        val.unidNeg &&
        val.unidNeg !== ''
      ) {
        const item = result.data.data['Saldo Clas Orctaria'].find(
          (item) =>
            item.cod_estab === val.estab.cod &&
            item.cod_unid_negoc === val.unidNeg.cod &&
            item.cod_ccusto === val.ccustos.cod,
        );

        if (item) {
          val.saldo = converToFloat2(item.sdo_calculado);
        }
      }
    });

    // result.data.data['Saldo Clas Orctaria'].forEach((sal, index) => {
    //   newFormValues[index]['saldo'] = converToFloat2(sal.sdo_calculado);
    // });
    setFormValues(newFormValues);
  };

  React.useEffect(() => {
    commbosData();

    if (searchParams.get('pagamento_id')) {
      setIsLoading(true);
    }
    getBancos();

    if (user && user.role_id == 6) {
      setFormValues([
        {
          estab: {
            id: 47,
            cod: 'SED',
            desc: 'SERVICO DE APOIO AS MICRO E PEQUENAS EMPRESAS DE MINAS GERAIS - SEBRAE/MG',
          },
          unidNeg: { id: 43, cod: '163', desc: 'Inovação e Mercado - UIMER' },
          ccustos: { id: 1231, cod: '5045406', desc: 'Projetos de Inovação' },
          contaContabil: {
            id: 390,
            cod: '31380103',
            desc: 'GESTÃO DE PROJETOS DE INOVAÇÃO',
          },
          saldo: 0,
          valor: 0,
        },
      ]);
      saldoSet([
        {
          estab: {
            id: 47,
            cod: 'SED',
            desc: 'SERVICO DE APOIO AS MICRO E PEQUENAS EMPRESAS DE MINAS GERAIS - SEBRAE/MG',
          },
          unidNeg: { id: 43, cod: '163', desc: 'Inovação e Mercado - UIMER' },
          ccustos: { id: 1231, cod: '5045406', desc: 'Projetos de Inovação' },
          contaContabil: {
            id: 390,
            cod: '31380103',
            desc: 'GESTÃO DE PROJETOS DE INOVAÇÃO',
          },
          saldo: 0,
          valor: 0,
        },
      ]);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async (data) => {
    if (!fornecedor) {
      setMessage('Selecione um fornecedor para continuar.');
      setType('Error');
      setShow(true);
      return;
    }
    setLoading(true);
    let errorFormValues = false;
    if (
      !['fundoFixo', 'pagamentoBolsistasAli', 'guiasTerceirizadas'].includes(
        data.tipo_documento,
      )
    ) {
      formValues.forEach((form) => {
        if (form.isContaContabil) {
          if (form.contaContabil == null) {
            setMessage(
              'Preencha corretamente todos os campos da classificação orçamentária.',
            );
            setType('Error');
            setShow(true);
            errorFormValues = true;
            setLoading(false);
            return;
          }
        } else {
          if (
            form.contaContabil &&
            form.contaContabil.desc.includes('TRANSITORIA')
          ) {
            if (
              form.estab == null ||
              form.contaContabil == null ||
              form.unidNeg == null
            ) {
              setMessage(
                'Preencha corretamente todos os campos da classificação orçamentária.',
              );
              setType('Error');
              setShow(true);
              errorFormValues = true;
              setLoading(false);
              return;
            }
          } else {
            if (
              form.estab == null ||
              form.ccustos == null ||
              form.contaContabil == null ||
              form.unidNeg == null
            ) {
              setMessage(
                'Preencha corretamente todos os campos da classificação orçamentária.',
              );
              setType('Error');
              setShow(true);
              errorFormValues = true;
              setLoading(false);
              return;
            }
          }
        }
        if (form.valor == 0 && !form.isContaContabil) {
          setMessage('O valor tem que ser maior que zero.');
          setType('Error');
          setShow(true);
          errorFormValues = true;
          setLoading(false);
          return;
        }

        const valor = parseFloat(form.valor);
        const saldo = parseFloat(form.saldo);

        if (form.isContaContabil === false && valor > saldo) {
          setMessage('O valor ultrapassa o seu saldo limite.');
          setType('Error');
          setShow(true);
          errorFormValues = true;
          setLoading(false);
          return;
        }
      });
    }

    if (errorFormValues) {
      setLoading(false);
      return;
    }

    setLoading(false);

    if (searchParams.get('pagamento_id')) {
      const pagamento_id = decryptData(searchParams.get('pagamento_id'));
      if (!pagamento_id) {
        return navigate('/dashboard/pagamento-direto');
      }

      data.id = pagamento_id;
    } else {
      data.justificativa =
        isCancelamentoCom == true ||
        isCancelamentoSem == true ||
        isPagamentoMaior == true
          ? txtJustificativa + ' ' + data.justificativa
          : data.justificativa;
    }

    if (!hideFields) {
      data.data_validade = Moment().format('YYYY-MM-DD');
    }

    data.data_abertura = Moment(data.data_abertura).format('YYYY-MM-DD');
    data.data_emissao = Moment(data.data_emissao).format('YYYY-MM-DD');
    data.periodo_entrega = Moment(data.periodo_entrega).format('YYYY-MM-DD');

    data.cnpj = fornecedor.cnpj_sem_pontos;
    data.razao_social = fornecedor.nome_fornec;
    data.cod_fornecedor = fornecedor.cod_fornec;
    data.classificacao_orcamentaria = formValues;
    data.portador = fornecedor.cod_portador;

    data.nome_usuario = user.nome_usuario;

    try {
      setLoading(false);
      setNumeroDocumentoFiscal(data.documento_fiscal);
      let result = await enviarPagamentoDireto(data);

      if (result && result.data && result.data.data && result.data.data.id) {
        setLoading(false);
        setPagamentoDiretoId(result.data.data.id);
        searchParams.set('pagamento_id', encryptData(result.data.data.id));
        setSearchParams(searchParams);

        if (fileImportedIA !== null) {
          const formData = new FormData();
          formData.append('arquivo', fileImportedIA);
          formData.append('tipo', 'adicional');

          await enviarArquivosPagamentoDireto(result.data.data.id, formData);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } catch (error) {
      setLoading(false);
      snackbar.showSnackbar(error.response.data.message);
    }
  };

  const onErrors = (errors) => {
    if (errors['periodo_entrega']) {
      if (datePeriodoPickerRef) {
        datePeriodoPickerRef.current.children[0].classList.add('Mui-error');
        datePeriodoPickerRef.current.children[1].classList.add('Mui-error');
      }
    }

    if (errors['data_emissao']) {
      if (datePickerRef) {
        datePickerRef.current.children[0].classList.add('Mui-error');
        datePickerRef.current.children[1].classList.add('Mui-error');
      }
    }

    if (errors['data_validade']) {
      if (dateValidadePickerRef) {
        dateValidadePickerRef.current.children[0].classList.add('Mui-error');
        dateValidadePickerRef.current.children[1].classList.add('Mui-error');
      }
    }
  };

  const arredondar = (n) => {
    return (Math.round(n * 100) / 100).toFixed(2);
  };

  const onChangeAutoComplete = (event) => {
    if (event.target.value.length > 0) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        fornecedores(event.target.value);
      }, 1000);
    } else {
      setOptions([]);
    }
  };

  const onChangeAutoCompleteCC = (event) => {
    if (event.target.value.length > 0) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        centroCusto(event.target.value);
      }, 1000);
    } else {
      setOptionsCCustos([]);
    }
  };

  let handleChange = async (i, e, value, name, element) => {
    let newFormValues = [...formValues];
    newFormValues[i][name] = value;

    if (name === 'contaContabil') {
      const isContaContabil =
        value !== null ? isUnnecessaryValidadeBalance(value) : false;
      element.isContaContabil = isContaContabil;
      if (isContaContabil) {
        const estab = optionsEstab.filter(({ cod }) => cod === 'SED')[0];
        const unidNeg = optionsUndNeg.filter(({ cod }) => cod === '115')[0];
        newFormValues = newFormValues.map((item) => {
          item.estab = estab;
          item.unidNeg = unidNeg;
          return item;
        });
      }
    }

    if (
      element &&
      element.contaContabil &&
      ['41210199', '18110108'].includes(element.contaContabil.cod)
    ) {
      setFormValues(newFormValues);
      return;
    }

    if (user && user.role_id != 6) {
      let numRateio = newFormValues.length;
      let percRateio = arredondar(100 / numRateio);
      let arrayParms = [];

      newFormValues.forEach((val, index) => {
        if (
          val.ccustos &&
          val.ccustos !== '' &&
          val.contaContabil &&
          val.contaContabil !== '' &&
          val.estab &&
          val.estab !== '' &&
          val.unidNeg &&
          val.unidNeg !== ''
        ) {
          arrayParms.push(
            `${percRateio}/${val.estab.cod}/${val.unidNeg.cod}/${val.ccustos.cod}/${val.contaContabil.cod}`,
          );
        } else {
          val.saldo = 0;
        }
      });

      let paramString = '';
      arrayParms.forEach((value, idx) => {
        if (arrayParms.length - 1 !== idx) {
          paramString += `${value},`;
        } else {
          paramString += value;
        }
      });
      if (paramString.length > 0) {
        await saldoData(paramString);
      }
    }

    setFormValues(newFormValues);
  };

  const isUnnecessaryValidadeBalance = ({ cod }) => {
    if (
      (cod !== null && cod.startsWith('1')) ||
      cod.startsWith('2') ||
      cod === '41210199'
    ) {
      return true;
    }

    return false;
  };

  let saldoSet = async (dataFormValues) => {
    let newFormValues = [...dataFormValues];

    let numRateio = newFormValues.length;
    let percRateio = arredondar(100 / numRateio);
    let arrayParms = [];

    newFormValues.forEach((val, index) => {
      if (
        val.ccustos &&
        val.ccustos !== '' &&
        val.contaContabil &&
        val.contaContabil !== '' &&
        val.estab &&
        val.estab !== '' &&
        val.unidNeg &&
        val.unidNeg !== ''
      ) {
        arrayParms.push(
          `${percRateio}/${val.estab.cod}/${val.unidNeg.cod}/${val.ccustos.cod}/${val.contaContabil.cod}`,
        );
      }
    });

    let paramString = '';
    arrayParms.forEach((value, idx) => {
      if (arrayParms.length - 1 !== idx) {
        paramString += `${value},`;
      } else {
        paramString += value;
      }
    });

    if (paramString.length > 0) {
      await saldoData(paramString);
    }
  };

  let addFormFields = () => {
    if (user && user.role_id == 6) {
      setFormValues([
        ...formValues,
        {
          estab: {
            id: 47,
            cod: 'SED',
            desc: 'SERVICO DE APOIO AS MICRO E PEQUENAS EMPRESAS DE MINAS GERAIS - SEBRAE/MG',
          },
          unidNeg: { id: 43, cod: '163', desc: 'Inovação e Mercado - UIMER' },
          ccustos: { id: 1231, cod: '5045406', desc: 'Projetos de Inovação' },
          contaContabil: {
            id: 390,
            cod: '31380103',
            desc: 'GESTÃO DE PROJETOS DE INOVAÇÃO',
          },
          saldo: saldo,
          valor: 0,
        },
      ]);
    } else {
      setFormValues([
        ...formValues,
        {
          estab: null,
          unidNeg: null,
          ccustos: null,
          contaContabil: null,
          saldo: 0,
          valor: 0,
        },
      ]);
    }
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) =>
      option.cnpj_sem_pontos +
      option.nome_fornec +
      option.cnpj_fornec +
      option.cod_emitente,
  });

  const filterOptionsEstab = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.cod + option.desc,
  });

  const filterOptionsContaContabil = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.cod + option.desc,
  });

  const filterOptionsCCustos = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.cod + option.desc,
  });

  const filterOptionsUnidNegocio = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.cod + option.desc,
  });

  const downlodModelo = () => {
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = `${process.env.REACT_APP_API_BASE_URL}ModeloImportacaoClassOrcamentaria.xlsx`;
    link.click();
  };

  const getTotalClasstificacaoOrcamentario = () => {
    let total = 0;
    formValues.map((item) => {
      total += item.valor;
    });
    if (isNaN(total)) return '-';

    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(total);
  };

  const onChangeTipoDocumento = (valor) => {
    switch (valor) {
      case 'fundoFixo':
      case 'pagamentoBolsistasAli':
      case 'guiasTerceirizadas':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(false);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(false);
        break;
      case 'fatura':
      case 'guiasTaxasISS':
      case 'reembolso':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(false);
        break;
      case 'antecipacaoFornecedores':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(true);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(false);
        break;
      case 'pagamentoDireto':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(false);
        break;
      case 'cancelaVendaDevolucao':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(true);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(false);
        break;
      case 'cancelaVendaComDevolucao':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(true);
        setIsPagamentoMaior(false);
        break;
      case 'pagamentoMaiorPeloCliente':
        setSolicPagamentoDireto(true);
        setDadosSolic(false);
        setDadosContratacao(true);
        setClassOrcamentaria(true);
        setJustifiqueMotivo(true);
        setHideFields(false);
        setIsAntecipacao(false);
        setIsCancelamentoSem(false);
        setIsCancelamentoCom(false);
        setIsPagamentoMaior(true);
        break;
    }
  };

  return (
    <Card
      variant="outline"
      style={{
        borderTop: `8px solid  ${theme.palette.primary.light}`,
        marginTop: '1.4rem',
      }}
    >
      {isLoading ? (
        <p>Carregando...</p>
      ) : (
        <CardContent
          style={{ padding: 0, border: '1px solid rgba(0, 0, 0, 0.12)' }}
        >
          <CustomizedDialogs
            content={message}
            btnTxt={'Ok'}
            type={type}
            onClick={() => setShow(false)}
            handleClose={handleClose}
            visible={show}
          />
          <form onSubmit={handleSubmit(onSubmit, onErrors)}>
            <Grid container spacing={2}>
              {solicPagamentoDireto ? (
                <Grid
                  style={{ backgroundColor: '#E7F0FF', paddingTop: 0 }}
                  container
                  sm={12}
                  item
                  justifyContent={'space-between'}
                >
                  <p style={{ color: '#006EB3', padding: '0 10px' }}>
                    Solicitação de Pagamento Direto
                  </p>
                </Grid>
              ) : null}
              {solicPagamentoDireto ? (
                <Grid
                  container
                  spacing={2}
                  paddingLeft={4}
                  paddingRight={4}
                  paddingTop={2}
                >
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="solicitacao"
                      control={control}
                      defaultValue={''}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          disabled={true}
                          margin="normal"
                          label="Solicitação"
                          value={value}
                          type="text"
                          id="solicitacao"
                          onChange={onChange}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="data_abertura"
                      defaultValue={new Date()}
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <Box style={{ paddingTop: 16, width: '100%' }}>
                            <MobileDatePicker
                              label="Data abertura"
                              inputFormat="DD/MM/YYYY"
                              value={value}
                              disabled={true}
                              maxDate={new Date()}
                              onChange={(event) => {
                                onChange(event);
                                // notaFiscal.data_emissao_nf =
                                //     Moment(event).format("YYYY-MM-DD");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  error={false}
                                  style={{ width: '100%' }}
                                  {...params}
                                />
                              )}
                            />
                          </Box>
                        </LocalizationProvider>
                      )}
                    />
                  </Grid>
                </Grid>
              ) : null}
              {dadosContratacao ? (
                <Grid
                  marginTop={3}
                  style={{
                    backgroundColor: '#E7F0FF',
                    paddingTop: 0,
                    marginBottom: 15,
                  }}
                  container
                  sm={12}
                  item
                  justifyContent={'space-between'}
                >
                  <p style={{ color: '#006EB3', padding: '0 10px' }}>
                    Dados da Contratação
                  </p>
                </Grid>
              ) : null}
              {dadosContratacao ? (
                <Grid
                  container
                  spacing={2}
                  paddingLeft={4}
                  paddingRight={4}
                  paddingTop={2}
                >
                  <Grid
                    container
                    sm={
                      isCancelamentoCom == false &&
                      isCancelamentoSem == false &&
                      isPagamentoMaior == false
                        ? 4
                        : 6
                    }
                    style={{ paddingTop: 0 }}
                    item
                  >
                    <Controller
                      name="tipo_documento"
                      id="tipo_documento"
                      rules={{
                        required: 'Tipo documento é obrigatório',
                        validate: (value) => {
                          return value !== 0;
                        },
                      }}
                      defaultValue={0}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          style={{ height: 40 }}
                          error={error}
                          onChange={(e) => {
                            onChange(e);
                            onChangeTipoDocumento(e.target.value);
                          }}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Selecione o tipo de documento
                          </MenuItem>
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'fundoFixo'}>FUNDO FIXO</MenuItem>
                          ) : null}
                          {user && [4, 7, 1].includes(user.role_id) ? (
                            <MenuItem value={'ugpFolha'}>UGP FOLHA</MenuItem>
                          ) : null}
                          {user && [4, 7, 1].includes(user.role_id) ? (
                            <MenuItem value={'ugpTributos'}>
                              UGP TRIBUTOS
                            </MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'fatura'}>FATURA</MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'guiasTaxasISS'}>
                              GUIA/TAXA/ISS
                            </MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'pagamentoDireto'}>
                              PAGAMENTO DIRETO
                            </MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'reembolso'}>REEMBOLSO</MenuItem>
                          ) : null}
                          {user && user.role_id === 6 ? (
                            <MenuItem value={'pagamentoAliTd'}>
                              PAGAMENTO-ALI-TD
                            </MenuItem>
                          ) : null}
                          {user && [1, 2].includes(user.role_id) ? (
                            <MenuItem value={'pagamentoBolsistasAli'}>
                              PAGAMENTO BOLSISTAS ALI
                            </MenuItem>
                          ) : null}
                          {user && [1, 2].includes(user.role_id) ? (
                            <MenuItem value={'guiasTerceirizadas'}>
                              GUIAS TERCEIRIZADAS
                            </MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'antecipacaoFornecedores'}>
                              ANTECIPAÇÃO A FORNECEDORES
                            </MenuItem>
                          ) : null}
                          {/* <MenuItem value={'cancelaVendaDevolucao'}>
                                                        CANCELAMENTO DE VENDA SEM DEVOLUÇÃO
                                                    </MenuItem> */}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'cancelaVendaComDevolucao'}>
                              CANCELAMENTO DE VENDA COM DEVOLUÇÃO
                            </MenuItem>
                          ) : null}
                          {user && user.role_id !== 6 ? (
                            <MenuItem value={'pagamentoMaiorPeloCliente'}>
                              PAGAMENTO A MAIOR EFETUADO PELO CLIENTE
                            </MenuItem>
                          ) : null}
                        </Select>
                      )}
                    />
                  </Grid>
                  {isCancelamentoCom == false &&
                  isCancelamentoSem == false &&
                  isPagamentoMaior == false ? (
                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Controller
                        name="forma_pagamento"
                        id="forma_pagamento"
                        rules={{
                          required: 'campo é obrigatório',
                          validate: (value) => {
                            return value !== 0;
                          },
                        }}
                        defaultValue={0}
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <Select
                            value={value}
                            style={{ height: 40 }}
                            error={error}
                            defaultValue={
                              pagamento && pagamento.forma_pagamento
                            }
                            onChange={(e) => {
                              onChange(e);
                              setValue('forma_pagamento', e.target.value);
                              setFormPagamentoSelecionado(e.target.value);
                            }}
                            fullWidth
                          >
                            <MenuItem disabled value={0}>
                              Selecione a forma de pagamento
                            </MenuItem>
                            {user && user.role_id !== 6 ? (
                              <MenuItem value={'Boleto'}>Boleto</MenuItem>
                            ) : null}
                            <MenuItem value={'DOC'}>DOC</MenuItem>
                            <MenuItem value={'FaturaCtaConsumo'}>
                              FATURA CTA CONSUMO
                            </MenuItem>
                          </Select>
                        )}
                      />
                    </Grid>
                  ) : null}

                  <Grid
                    container
                    sm={
                      isCancelamentoCom == false &&
                      isCancelamentoSem == false &&
                      isPagamentoMaior == false
                        ? 4
                        : 6
                    }
                    style={{ paddingTop: 0 }}
                    item
                  >
                    <Box style={{ width: '100%' }}>
                      <Autocomplete
                        noOptionsText="Nenhuma opção encontrada"
                        loadingText="Carregando..."
                        getOptionLabel={(option) =>
                          `${option.nome_fornec} - ${option.cnpj_fornec}`
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.cnpj_sem_pontos === value.cnpj_sem_pontos
                        }
                        options={options}
                        id="controlled-demo"
                        fullWidth
                        value={fornecedor}
                        disabled={!getValues('tipo_documento')}
                        loading={loadingAutocomplete}
                        filterOptions={filterOptions}
                        onChange={(event, newValue, reason) => {
                          if (reason === 'clear') {
                            setValue('email', '');
                            setValue('telefone', '');
                            return;
                          }
                          setFornecedor(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            onChange={onChangeAutoComplete}
                            {...params}
                            label="Fornecedor Nome ou CNPJ"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loadingAutocomplete ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="telefone"
                      control={control}
                      defaultValue={pagamento && pagamento.telefone}
                      rules={{ required: 'telefone é obrigatório' }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          label="Telefone"
                          InputLabelProps={{
                            shrink: getValues('telefone') !== null,
                          }}
                          value={value}
                          type="text"
                          id="telefone"
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="email"
                      control={control}
                      defaultValue={pagamento && pagamento.email}
                      rules={{ required: 'e-mail é obrigatório' }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          label="E-mail"
                          InputLabelProps={{
                            shrink: getValues('email') !== null,
                          }}
                          value={value}
                          type="text"
                          id="email"
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="data_emissao"
                      defaultValue={''}
                      control={control}
                      rules={{
                        required: 'campo é obrigatório',
                        validate: (value) => {
                          return value !== null || value !== undefined;
                        },
                      }}
                      render={({ field: { value, onChange } }) => (
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <Box style={{ paddingTop: 16, width: '100%' }}>
                            <MobileDatePicker
                              ref={datePickerRef}
                              label="Data emissão"
                              inputFormat="DD/MM/YYYY"
                              value={value}
                              maxDate={new Date()}
                              onChange={(event) => {
                                onChange(event);
                                // notaFiscal.data_emissao_nf =
                                //     Moment(event).format("YYYY-MM-DD");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  error={false}
                                  style={{ width: '100%' }}
                                  {...params}
                                />
                              )}
                            />
                          </Box>
                        </LocalizationProvider>
                      )}
                    />
                  </Grid>

                  {!hideFields ? (
                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Controller
                        name="data_validade"
                        defaultValue={''}
                        control={control}
                        rules={{
                          required: 'campo é obrigatório',
                          validate: (value) => {
                            return value !== null || value !== undefined;
                          },
                        }}
                        render={({ field: { value, onChange } }) => (
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <Box style={{ paddingTop: 16, width: '100%' }}>
                              <MobileDatePicker
                                ref={dateValidadePickerRef}
                                label={'Data vencimento'}
                                inputFormat="DD/MM/YYYY"
                                value={value}
                                minDate={new Date()}
                                onChange={(event) => {
                                  onChange(event);
                                  // notaFiscal.data_emissao_nf =
                                  //     Moment(event).format("YYYY-MM-DD");
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    error={false}
                                    style={{ width: '100%' }}
                                    {...params}
                                  />
                                )}
                              />
                            </Box>
                          </LocalizationProvider>
                        )}
                      />
                    </Grid>
                  ) : null}
                  {isAntecipacao &&
                  isCancelamentoCom == false &&
                  isCancelamentoSem == false &&
                  isPagamentoMaior == false ? (
                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Controller
                        name="periodo_entrega"
                        defaultValue={''}
                        rules={{
                          required: 'campo é obrigatório',
                          validate: (value) => {
                            return value !== null || value !== undefined;
                          },
                        }}
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <Box style={{ paddingTop: 16, width: '100%' }}>
                              <MobileDatePicker
                                ref={datePeriodoPickerRef}
                                label={
                                  'Período final de execução ou entrega do produto'
                                }
                                inputFormat="DD/MM/YYYY"
                                value={value}
                                minDate={new Date()}
                                onChange={(event) => {
                                  onChange(event);
                                  // notaFiscal.data_emissao_nf =
                                  //     Moment(event).format("YYYY-MM-DD");
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    error={errors['periodo_entrega']}
                                    style={{ width: '100%' }}
                                    {...params}
                                  />
                                )}
                              />
                            </Box>
                          </LocalizationProvider>
                        )}
                      />
                    </Grid>
                  ) : null}
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="documento_fiscal"
                      control={control}
                      defaultValue={''}
                      rules={{ required: 'campo é obrigatório' }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          label={
                            isPagamentoMaior ||
                            isCancelamentoCom ||
                            isCancelamentoSem
                              ? 'Número da Venda/Contrato'
                              : 'Número do Documento Fiscal'
                          }
                          value={value}
                          type="number"
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value),
                            )
                              .toString()
                              .slice(0, 16);
                            onChangeTxtJustificativa();
                          }}
                          inputProps={{
                            min: 0,
                            maxLength: 16,
                          }}
                          id="documento_fiscal"
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  {['Boleto', 'FaturaCtaConsumo'].includes(
                    formPagamentoSelecionado,
                  ) && (
                    <>
                      <Grid container sm={4} style={{ paddingTop: 0 }} item>
                        <Controller
                          name="codigo_boleto"
                          control={control}
                          defaultValue={''}
                          render={({
                            field: { onChange, value },
                            fieldState: { error },
                          }) => (
                            <TextField
                              margin="normal"
                              label="Código de barras"
                              value={value}
                              id="codigo_boleto"
                              error={error}
                              helperText={error && error.message}
                              onChange={onChange}
                              fullWidth
                            />
                          )}
                        />
                      </Grid>
                      <Grid
                        container
                        sm={4}
                        style={{ paddingTop: 0, marginBottom: 10 }}
                        item
                      >
                        <Button
                          style={{ width: '100%', height: 40 }}
                          variant="contained"
                          component="label"
                        >
                          <UploadIcon />
                          Importar documento por IA
                          <input
                            hidden
                            accept="application/pdf"
                            type="file"
                            onChange={onChangeFile}
                          />
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              ) : null}
              {isCancelamentoCom == true ||
              isCancelamentoSem == true ||
              isPagamentoMaior == true ? (
                <Grid
                  container
                  spacing={2}
                  paddingLeft={4}
                  paddingRight={4}
                  paddingTop={4}
                >
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="instrumento"
                      id="instrumento"
                      rules={{
                        required: 'campo é obrigatório',
                        validate: (value) => {
                          return value !== 0;
                        },
                      }}
                      defaultValue={0}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          style={{ height: 40 }}
                          error={error}
                          defaultValue={pagamento && pagamento.instrumento}
                          onChange={(e) => {
                            onChange(e);
                          }}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Selecione o Instrumento
                          </MenuItem>
                          <MenuItem value={'Demonstrativo'}>
                            Demonstrativo
                          </MenuItem>
                          <MenuItem value={'Contrato'}>Contrato</MenuItem>
                        </Select>
                      )}
                    />
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="cancelar"
                      id="cancelar"
                      rules={{
                        required: 'campo é obrigatório',
                        validate: (value) => {
                          return value !== 0;
                        },
                      }}
                      defaultValue={0}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          style={{ height: 40 }}
                          error={error}
                          defaultValue={pagamento && pagamento.cancelar}
                          onChange={(e) => {
                            onChange(e);
                            onChangeTxtJustificativa();
                          }}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Cancelar
                          </MenuItem>
                          <MenuItem value={'Parcialmente'}>
                            Parcialmente
                          </MenuItem>
                          <MenuItem value={'Totalmente'}>Totalmente</MenuItem>
                        </Select>
                      )}
                    />
                  </Grid>
                  <Grid container sm={4} style={{ paddingTop: 0 }} item>
                    <Controller
                      name="contrato_assinado"
                      id="contrato_assinado"
                      rules={{
                        required: 'campo é obrigatório',
                        validate: (value) => {
                          return value !== 0;
                        },
                      }}
                      defaultValue={0}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          style={{ height: 40 }}
                          error={error}
                          defaultValue={
                            pagamento && pagamento.contrato_assinado
                          }
                          onChange={(e) => {
                            onChange(e);
                          }}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Contrato Assinado
                          </MenuItem>
                          <MenuItem value={'Sim'}>Sim</MenuItem>
                          <MenuItem value={'Não'}>Não</MenuItem>
                        </Select>
                      )}
                    />
                  </Grid>
                  <Grid container sm={12} style={{ paddingTop: 0 }} item>
                    <Box style={{ width: '100%' }}>
                      <Controller
                        name="descricao_servico"
                        control={control}
                        rules={{ required: 'Campo é obrigatório' }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            margin="normal"
                            value={value}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            multiline
                            rows={4}
                            fullWidth
                            placeholder="Digite a descrição do serviço"
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                </Grid>
              ) : null}
              {isCancelamentoCom == true || isPagamentoMaior == true ? (
                <Grid
                  container
                  spacing={2}
                  paddingLeft={4}
                  paddingRight={4}
                  paddingTop={4}
                >
                  <Grid container sm={12} item>
                    <label style={{ color: '#707070' }}>
                      Endereço completo:
                    </label>
                    <Controller
                      rules={{
                        required: 'Campo é obrigatória',
                      }}
                      name="endereco"
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          style={{ marginTop: '5px' }}
                          margin="normal"
                          value={value}
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          placeholder="Digite o endereço"
                        />
                      )}
                    />
                  </Grid>
                  <Grid container sm={6} style={{ paddingTop: 15 }} item>
                    <label style={{ color: '#707070' }}>
                      Forma de pagamento
                    </label>
                    <Controller
                      name="forma_pagamento"
                      id="forma_pagamento"
                      rules={{
                        required: 'campo é obrigatório',
                        validate: (value) => {
                          return value !== 0;
                        },
                      }}
                      defaultValue={0}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          style={{ height: 40 }}
                          error={error}
                          defaultValue={pagamento && pagamento.forma_pagamento}
                          onChange={(e) => {
                            onChange(e);
                            if (e.target.value == 'Ordem de Pagamento') {
                              setIsOrdemPagamento(true);
                            } else {
                              setIsOrdemPagamento(false);
                            }
                          }}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Selecione a forma de pagamento
                          </MenuItem>
                          <MenuItem value={'Ordem de Pagamento'}>
                            Ordem de Pagamento
                          </MenuItem>
                          <MenuItem value={'DOC/TED'}>DOC/TED</MenuItem>
                        </Select>
                      )}
                    />
                  </Grid>
                  {isOrdemPagamento ? (
                    <Grid container sm={6} item>
                      <p
                        style={{
                          color: '#006EB3',
                          padding: '0 10px',
                          justifyContent: 'center',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: 12,
                          width: '100%',
                        }}
                      >
                        {' '}
                        <ErrorIcon
                          color="primary"
                          size={20}
                          style={{ marginRight: 10 }}
                        />{' '}
                        Atenção: Informar ao cliente para resgatar o valor em
                        uma agência do Banco do Brasil em até 30 dias.
                      </p>
                    </Grid>
                  ) : null}
                  {!isOrdemPagamento ? (
                    <Grid container sm={6} item>
                      <label style={{ color: '#707070' }}>Banco:</label>
                      <Controller
                        name="banco"
                        rules={{
                          required: 'Banco é obrigatório',
                          validate: (value) => {
                            return value !== null;
                          },
                        }}
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <Select
                            value={value}
                            style={{ height: 38 }}
                            error={error}
                            onChange={(e) => {
                              onChange(e);
                            }}
                            fullWidth
                          >
                            <MenuItem disabled value={null}>
                              Escolha o banco
                            </MenuItem>
                            {bancos &&
                              bancos.length > 0 &&
                              bancos.map((banco) => {
                                return (
                                  <MenuItem value={banco.banco}>
                                    {banco.codigo} - {banco.banco}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        )}
                      />
                    </Grid>
                  ) : null}
                  {!isOrdemPagamento ? (
                    <Grid container sm={4} item>
                      <label style={{ color: '#707070' }}>Agência:</label>
                      <Controller
                        rules={{
                          required: 'Agência é obrigatória',
                        }}
                        name="agencia"
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            type={'number'}
                            style={{ marginTop: '5px' }}
                            margin="normal"
                            value={value}
                            label="Agência"
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                            placeholder="Digite a agência"
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                  {!isOrdemPagamento ? (
                    <Grid container sm={2} item>
                      <label style={{ color: '#707070' }}>
                        Dígito da Agência
                      </label>
                      <Controller
                        name="digito_agencia"
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            style={{ marginTop: '5px' }}
                            type={'number'}
                            margin="normal"
                            value={value}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                            placeholder="Digite"
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                  {!isOrdemPagamento ? (
                    <Grid container sm={4} item>
                      <label style={{ color: '#707070' }}>Conta:</label>
                      <Controller
                        rules={{
                          required: 'Conta é obrigatória',
                        }}
                        name="conta"
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            style={{ marginTop: '5px' }}
                            type={'number'}
                            margin="normal"
                            value={value}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                            placeholder="Digite a conta"
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                  {!isOrdemPagamento ? (
                    <Grid container sm={2} item>
                      <label style={{ color: '#707070' }}>
                        Dígito da conta
                      </label>
                      <Controller
                        rules={{
                          required: 'Dígito é obrigatóriao',
                        }}
                        name="digito"
                        control={control}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            type={'number'}
                            style={{ marginTop: '5px' }}
                            margin="normal"
                            value={value}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                            placeholder="Digite"
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              ) : null}
              {classOrcamentaria ? (
                <Grid
                  style={{
                    backgroundColor: '#F4F8FF',
                    paddingTop: 0,
                    paddingRight: 20,
                    paddingLeft: 20,
                  }}
                  container
                  sm={12}
                  item
                  justifyContent={'space-between'}
                >
                  <Grid marginTop={3} item>
                    <p style={{ color: '#006EB3', padding: '0 10px' }}>
                      Classificação orçamentária
                    </p>
                  </Grid>
                  <Grid marginTop={3} item>
                    <Button
                      style={{}}
                      disabled={user && user.role_id === 6}
                      variant="contained"
                      type="button"
                      onClick={() => addFormFields()}
                    >
                      Adicionar
                    </Button>
                  </Grid>
                </Grid>
              ) : null}

              {isUsuarioSebrae &&
                ![
                  'fundoFixo',
                  'pagamentoBolsistasAli',
                  'guiasTerceirizadas',
                ].includes(getValues('tipo_documento')) && (
                  <Grid
                    style={{ backgroundColor: '#F4F8FF', paddingTop: 0 }}
                    container
                    sm={12}
                    item
                  >
                    <Button
                      variant="contained"
                      style={{ margin: 10 }}
                      component="label"
                      disabled={loadingAutocompleteOrc}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <span> Importar planilha</span>
                      </Box>
                      <FileUploadIcon
                        style={{ color: 'white', marginLeft: 5 }}
                      />
                      <input
                        hidden
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        type="file"
                        onChange={onChangeXlsx}
                      />
                    </Button>
                    <Button
                      variant="contained"
                      style={{ margin: 10 }}
                      component="label"
                      onClick={downlodModelo}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <span>Baixar modelo</span>
                      </Box>
                      <DownloadIcon style={{ color: 'white', marginLeft: 5 }} />
                    </Button>
                  </Grid>
                )}

              {classOrcamentaria ? (
                <Grid
                  style={{ backgroundColor: '#F4F8FF', paddingTop: 0 }}
                  container
                  sm={12}
                  item
                  justifyContent={'space-between'}
                >
                  <p
                    style={{
                      color: '#006EB3',
                      padding: '0 10px',
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 12,
                      width: '100%',
                    }}
                  >
                    {' '}
                    <ErrorIcon
                      color="primary"
                      size={20}
                      style={{ marginRight: 10 }}
                    />{' '}
                    Atenção: Se faz necessário inserir o documento que deverá
                    ser lançado/gerido pela Central de Notas (na aba "Carregar
                    anexos")
                  </p>
                </Grid>
              ) : null}
              {classOrcamentaria &&
                formValues.map((element, index) => (
                  <Grid
                    container
                    sm={12}
                    style={{ paddingTop: 0 }}
                    item
                    key={index}
                  >
                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Box
                        style={{ width: '100%', marginLeft: 15, marginTop: 15 }}
                      >
                        <Autocomplete
                          style={{ width: '100%' }}
                          noOptionsText="Nenhuma opção encontrada"
                          loadingText="Carregando..."
                          getOptionLabel={(option) =>
                            `${option.cod} - ${option.desc}`
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.cod === value.cod
                          }
                          disabled={user && user.role_id == 6}
                          options={optionsContaContabil}
                          value={element.contaContabil || null}
                          loading={loadingAutocompleteOrc}
                          filterOptions={filterOptionsContaContabil}
                          onChange={(event, newValue) => {
                            handleChange(
                              index,
                              event,
                              newValue,
                              'contaContabil',
                              element,
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="contaContabil"
                              label={`Conta contábil`}
                              isOptionEqualToValue={(option, value) =>
                                option.cod === value.cod
                              }
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loadingAutocompleteOrc ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                    </Grid>

                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Box
                        style={{
                          width: '100%',
                          marginLeft: 15,
                          marginTop: 15,
                        }}
                      >
                        <Autocomplete
                          style={{ width: '100%' }}
                          noOptionsText="Nenhuma opção encontrada"
                          loadingText="Carregando..."
                          getOptionLabel={(option) =>
                            `${option.cod} - ${option.desc}`
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.cod === value.cod
                          }
                          disabled={user && user.role_id == 6}
                          options={optionsEstab}
                          value={element.estab || null}
                          loading={loadingAutocompleteOrc}
                          filterOptions={filterOptionsEstab}
                          onChange={(event, newValue) =>
                            handleChange(index, event, newValue, 'estab')
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="estab"
                              label="Estab."
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loadingAutocompleteOrc ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                    </Grid>

                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Box
                        style={{
                          width: '100%',
                          marginRight: 15,
                          marginLeft: 15,
                          marginTop: 15,
                        }}
                      >
                        <Autocomplete
                          style={{ width: '100%' }}
                          noOptionsText="Nenhuma opção encontrada"
                          loadingText="Carregando..."
                          getOptionLabel={(option) =>
                            `${option.cod} - ${option.desc}`
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.cod === value.cod
                          }
                          disabled={user && user.role_id == 6}
                          options={optionsUndNeg}
                          value={element.unidNeg || null}
                          loading={loadingAutocompleteOrc}
                          filterOptions={filterOptionsUnidNegocio}
                          onChange={(event, newValue) =>
                            handleChange(index, event, newValue, 'unidNeg')
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="unidNeg"
                              label="Unidade Negocio"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loadingAutocompleteOrc ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                    </Grid>

                    {!element.isContaContabil ||
                    (element.contaContabil &&
                      ['41210199', '18110108'].includes(
                        element.contaContabil.cod,
                      )) ? (
                      <Grid container sm={4} style={{ padding: 0 }} item>
                        <Box
                          style={{
                            width: '100%',
                            marginLeft: 15,
                            marginTop: 15,
                          }}
                        >
                          <Autocomplete
                            style={{ width: '100%' }}
                            noOptionsText="Nenhuma opção encontrada"
                            loadingText="Carregando..."
                            getOptionLabel={(option) =>
                              `${option.cod} - ${option.desc}`
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.cod === value.cod
                            }
                            disabled={user && user.role_id == 6}
                            options={optionsCCustos}
                            value={element.ccustos || null}
                            loading={loadingAutocompleteOrc}
                            filterOptions={filterOptionsCCustos}
                            onChange={(event, newValue) => {
                              handleChange(index, event, newValue, 'ccustos');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="ccustos"
                                label="Centro Custo"
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {loadingAutocompleteOrc ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Box>
                      </Grid>
                    ) : null}

                    {!element.isContaContabil ? (
                      <Grid container sm={4} style={{ paddingTop: 0 }} item>
                        <Box
                          style={{
                            width: '100%',
                            marginLeft: 15,
                            marginTop: 15,
                          }}
                        >
                          <CurrencyTextField
                            label="Saldo"
                            variant="outlined"
                            value={element.saldo || 0}
                            disabled={true}
                            fullWidth
                            decimalCharacter=","
                            digitGroupSeparator="."
                            currencySymbol="R$"
                            error={
                              !element.isContaContabil && element.saldo === 0
                            }
                            onChange={(event, value) =>
                              handleChange(index, event, value, 'saldo')
                            }
                          />
                        </Box>
                      </Grid>
                    ) : null}

                    <Grid container sm={4} style={{ paddingTop: 0 }} item>
                      <Box
                        style={{
                          width: '100%',
                          marginLeft: 15,
                          marginRight: 15,
                          marginTop: 15,
                        }}
                      >
                        <CurrencyTextField
                          label="Valor"
                          variant="outlined"
                          value={element.valor || ''}
                          disabled={!isValidRowClassificacaoOrcamentaria(index)}
                          fullWidth
                          minimumValue={'0'}
                          maximumValue={
                            user && user.role_id == 6 ? '2000' : '99999999999'
                          }
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          onChange={(event, value) =>
                            handleChange(index, event, value, 'valor')
                          }
                        />

                        {!isValidRowClassificacaoOrcamentaria(index) && (
                          <small style={{ color: 'red' }}>
                            Classificação não possui saldo
                          </small>
                        )}
                      </Box>
                    </Grid>

                    {index ? (
                      <Grid container sm={4} style={{ paddingTop: 0 }} item>
                        <Button
                          style={{
                            width: '100%',
                            height: 40,
                            marginTop: 15,
                            marginLeft: 15,
                            marginRight: 15,
                          }}
                          type="button"
                          variant="contained"
                          onClick={() => removeFormFields(index)}
                        >
                          Remover
                        </Button>
                      </Grid>
                    ) : (
                      <Grid
                        container
                        sm={4}
                        style={{ paddingTop: 0 }}
                        item
                      ></Grid>
                    )}
                  </Grid>
                ))}

              {![
                'fundoFixo',
                'pagamentoBolsistasAli',
                'guiasTerceirizadas',
              ].includes(getValues('tipo_documento')) && (
                <Grid
                  marginTop={3}
                  style={{ backgroundColor: '#E7F0FF', paddingTop: 0 }}
                  container
                  sm={12}
                  item
                  justifyContent="end"
                >
                  <p style={{ color: '#DC143C', padding: '0 10px' }}>
                    Total: {getTotalClasstificacaoOrcamentario()}
                  </p>
                </Grid>
              )}

              {justifiqueMotivo ? (
                <Grid
                  marginTop={3}
                  style={{ backgroundColor: '#E7F0FF', paddingTop: 0 }}
                  container
                  sm={12}
                  item
                  justifyContent={'space-between'}
                >
                  <p style={{ color: '#006EB3', padding: '0 10px' }}>
                    Justifique o motivo do lançamento por débito direto
                  </p>
                </Grid>
              ) : null}
              {justifiqueMotivo ? (
                <Grid container sm={12} style={{ paddingTop: 0 }} item>
                  <Box style={{ width: '100%', margin: 15 }}>
                    {isCancelamentoCom == true ||
                    isCancelamentoSem == true ||
                    isPagamentoMaior == true ? (
                      <p>{txtJustificativa}</p>
                    ) : null}
                    <Controller
                      name="justificativa"
                      control={control}
                      rules={{ required: 'Justificativa é obrigatório' }}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          multiline
                          rows={4}
                          inputProps={{ maxLength: 600 }}
                          fullWidth
                          placeholder="Digite sua justificativa"
                        />
                      )}
                    />
                  </Box>
                </Grid>
              ) : null}
            </Grid>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                pt: 2,
                justifyContent: 'space-between',
              }}
            >
              <Button
                type="button"
                variant="contained"
                style={{ marginRight: '0.5rem', width: '100%' }}
                onClick={() => {
                  navigate(`/dashboard/pagamento-direto`);
                }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                disabled={loading}
                style={{ width: '100%' }}
                variant="contained"
                onClick={() => {
                  // setIsRascunho(false);
                }}
              >
                Próximo
              </Button>
            </Box>
          </form>
        </CardContent>
      )}
    </Card>
  );
};
